"use client";

import { BSRMinimize } from "./bsr/BSRMinimize";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Minimize as LegacyMinimize } from "./legacy/Minimize";

export const Minimize = createBSRExperimentIcon(LegacyMinimize, BSRMinimize);
